import { createContext, useContext, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import queryString from "query-string";

import api from "libs/api";
import website_status_data from "libs/website_status_data.json";

const ClientsContext = createContext();

const ClientsProvider = ({ children }) => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const filters = queryString.parse(search);
  const default_sort = "tasks:desc";

  const [init_loading, setInitLoading] = useState(true);

  const { isLoading: loading, data: clients } = useQuery(
    ["clients", filters],
    () =>
      api.get(
        `/admin/clients?${queryString.stringify({
          ...filters,
          type:
            website_status_data?.find((item) => item?.key === filters?.type)
              ?.value || undefined,
          sort: filters?.sort || default_sort,
        })}`
      ),
    {
      onSuccess: () => {
        setInitLoading(false);
      },
    }
  );

  const filterHandler = (name, value) => {
    navigate(
      `/clients?${queryString.stringify({
        ...filters,
        [name]: value || undefined,
      })}`
    );
  };

  const value = useMemo(() => {
    return {
      data: clients,
      loading,
      init_loading,
      filters,
      filterHandler,
    };
    // eslint-disable-next-line
  }, [clients, loading, init_loading, filters]);

  return (
    <ClientsContext.Provider value={value}>{children}</ClientsContext.Provider>
  );
};

const useClients = () => useContext(ClientsContext);
export { ClientsContext, useClients };
export default ClientsProvider;
